import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

export interface OrderActionsCellRendererParams {
  onMoverCarga?: (data: any) => void;
}

/**
 * Order Actions Cell Renderer
 *
 * Displays an action menu with options for order operations.
 * Currently includes "Mover Carga" option.
 *
 * @example
 * ```typescript
 * {
 *   colId: 'actions',
 *   headerName: '',
 *   cellRenderer: OrderActionsCellRendererComponent,
 *   cellRendererParams: {
 *     onMoverCarga: (data: any) => this.handleMoverCarga(data)
 *   } as OrderActionsCellRendererParams,
 *   width: 80,
 *   sortable: false,
 *   filterable: false
 * }
 * ```
 */
@Component({
  selector: 'app-order-actions-cell-renderer',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatMenuModule, MatTooltipModule],
  template: `
    <button
      mat-icon-button
      [matMenuTriggerFor]="actionMenu"
      matTooltip="Acciones">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #actionMenu="matMenu">
      <button mat-menu-item (click)="onMoverCargaClick($event)">
        <mat-icon svgIcon="heroicons_outline:arrow-up-on-square-stack"></mat-icon>
        Mover Carga
      </button>
    </mat-menu>
  `,
})
export class OrderActionsCellRendererComponent implements CellRenderer<any> {
  @Input() params!: CellRendererParams<any>;

  get customParams(): OrderActionsCellRendererParams | undefined {
    return this.params?.colDef?.cellRendererParams as OrderActionsCellRendererParams;
  }

  onMoverCargaClick(event: Event): void {
    event.stopPropagation();
    if (this.customParams?.onMoverCarga && this.params?.data) {
      this.customParams.onMoverCarga(this.params.data);
    }
  }
}
